module.exports = __webpack_public_path__ + "static/img/zgmh.605ced06.jpg";